import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  FormControl,
  Checkbox,
  Select,
  MenuItem,
  Tooltip,
  ListItemText,
  Button,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import { format } from "mathjs";
import { getGlobalClientId, getToken,getOrgType } from "../../../../utils/Token";
import useFetch from "../../../../utils/useFetch";
import BaseURL from "../../../../utils/base-uri.json";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


export default function ReportSineproCheckInCheckout({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [sitedata, setSiteData] = React.useState([]);
  const [location, setLocation] = React.useState([]);
  const [token,setToken]=useState(getToken())
  useEffect(() => {
    axios
    .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
      getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res.data.data);
          if(getOrgType()=="Client"){
            setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const changeClients = (e) => {
    setSelectValue1(e);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  useEffect(() => {
    if(selectValue1){
     axios
     .get("Client/GetSineProSitesByClient?clientId=" + selectValue1)
       .then((res) => {
         if (res.data.responseCode === 100) {
           setLocation(res?.data?.data?.item2);
        
         } else {
           setError(res.data.responseMessage);
         }
       })
       .catch((err) => {
         console.log(err);
       });}
   }, [selectValue1]);
  // const { data: resp } = useFetch(
  //   "Client/GetBuSitesByClientId?clientId=" + selectValue1
  // );
  // useEffect(() => {
  //   if (resp?.data) {
  //     setSiteData(resp?.data);
  //   }
  // }, [resp]);
  // const { data: resps } = useFetch(
  //   "Vendor/GetLocationsByClientId?clientId=" + selectValue1
  // );
  // useEffect(() => {
  //   if (resps?.data) {
  //     setLocation(resps?.data);
  //   }
  // }, [resps]);
  const [showAlert, setShowAlert] = useState(false);

  const handleFromDateChange = (e) => {
    const newFromDate = e;
    setFromDateValue(newFromDate);

    // Check if From date is greater than To date
    if (newFromDate > toDateValue) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };

  const handleToDateChange = (e) => {
    const newToDate = e;
    setToDateValue(newToDate);

    // Check if From date is greater than To date
    if (fromDateValue > newToDate) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }
  };
  const [selectedsite, setSelectedsite] = useState([]);
  const [selectedlocation, setSelectedLocation] = useState([]);

  const handleDocTypeChange1 = (event) => {
    setSelectedsite(event.target.value);
  };

  const handleDocTypeChange2 = (event) => {
    setSelectedLocation(event.target.value);
  };

  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
 };
 location?.sort((a, b) => a.value.localeCompare(b.value));
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>
      {showAlert && (
          <div className="alert mx-5" style={{ color: "red" }}>
            From date should be less than To date
          </div>
        )}
        <form
          action={
            BaseURL?.baseReportUrl+"SineproCheckinCheckOut.aspx?menubar=no"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                From{" "}
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="fromDate"
                size="small"
                value={fromDateValue || ""}
                onChange={handleFromDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                To
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="toDate"
                size="small"
                value={toDateValue || ""}
                onChange={handleToDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
               <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register("client")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Client"
                    name="ClientId"
                    value={selectValue1}
                  />
                }
                MenuProps={MenuProps}
              >

                {client?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Locations
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                displayEmpty
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="Locationid"
                value={selectedlocation}
                onChange={handleDocTypeChange2}
                MenuProps={MenuProps}
             
              >
                 <MenuItem value="">
                  All
                  </MenuItem>
                {location
                ?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>

              {fromDateValue == "" ||
              toDateValue == "" ||
              selectValue1 == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        fromDateValue == "" ||
                        toDateValue == "" ||
                        selectValue1 == "" ||
                        selectedlocation == ""
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token}/>
        </form>

        <br />
      </DialogContent>
    </>
  );
}
